import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(75%)' }),
    animate('400ms 500ms'),
  ]),
  transition(
    ':leave',
    animate(400, style({ opacity: 0, transform: 'translateY(-75%)' }))
  ),
]);

export const fader = trigger('fader', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('200ms 300ms ease', style({ opacity: 1 })),
  ]),
  transition(':leave', [animate('200ms ease', style({ opacity: 0 }))]),
]);

export const slideIn = trigger('slideIn', [
  transition(':enter', [
    style({ insetInlineEnd: '-100%' }),
    animate('300ms ease', style({ insetInlineEnd: 0 })),
  ]),
  transition(':leave', [animate('300ms ease', style({ opacity: 0 }))]),
]);

export const slideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({ insetInlineEnd: '-100%' }),
    animate('300ms ease', style({ insetInlineEnd: 0 })),
  ]),
  transition(':leave', [
    animate('300ms ease', style({ insetInlineStart: '-100%' })),
  ]),
]);
